export const locale = {
  lang: 'fr',
  data: {
    publicMemberSearch: {
      speciality: 'Spécialité',
      municipality: 'Municipalité',
      bySpeciality: 'Par spécialité',
      byMunicipality: 'Par ville',
      searchForDentist: 'Chercher un dentiste',
      byPermitNumber: 'Par nom ou numéro de permis',
      searchResults: 'Résultats de recherche',
      newSearch: 'Nouvelle recherche',
      search: 'Rechercher',
      backToResults: 'Retour aux résultats',
      criterias: 'Critères de recherche: ',
      byAdministrativeRegion: 'Par région administrative',
      administrativeRegion: 'Région administrative',
      noResult: 'Pas de résultats avec ces critères de recherche',
      isAnesthesiaPrivateClinic: 'Soins dentaires sous anesthésie générale en clinique privée',
      isAnesthesiaHospital: 'Soins dentaires sous anesthésie générale en milieu hospitalier',
      isParticularMedicalCondition: 'Soins aux patients présentant une condition médicale particulière',
      isHomeVisit: "Soins dentaires à domicile",
      isSleepApnea: "Soins en lien avec le traitement de l’apnée du sommeil",
      isReducedMobility: 'Clinique dentaire accessible aux personnes à mobilité réduite',
      isLiftPerson: "Dispose d'un lève-personne",
      memberSpecification: 'Activités professionelles particulières'
    },
    memberPublicInfos: {
      memberInfos: 'Informations sur le membre',
      notAuthorizedMember: "(Non autorisé à exercer la médecine dentaire au Québec)",
      name: 'Nom',
      permitNumber: 'Numéro de permis',
      permitType: 'Type de permis',
      disciplinaryBoard: {
        label: 'Dossier(s) disciplinaire(s)',
        recordNumber: 'Numéro de dossier',
        date: 'Date',
        publicDecisionType: 'Décision',
        documents: 'Document(s)',
        atLeastOneFile: 'Au moins un dossier disciplinaire concernant ce membre (détails ci-dessous)',
        none: "Aucun dossier disciplinaire concernant ce membre"
      },
      inDateOf: 'En date de : ',
      effectiveExerciseStatus: {
        label: "Statut d'exercice",
        Active: 'Actif',
        Inactive: 'Inactif',
        Terminated: 'Terminé',
        NotAvailable: 'Non disponible',
        limitedPractice: "(le droit d'exercer de ce membre est limité)",
        none: "Aucun"
      },
      effectiveInscriptionStatus: {
        label: "Statut d'inscription",
        Registered: 'Inscrit',
        NotRegistered: 'Non-inscrit',
        PermanentNotRegistered: 'Non-inscrit',
        NotAvailable: 'Non disponible',
        NotAffected: 'Non affecté',
      },
      professionalDomicile: {
        clinicName: 'Clinique',
        address: 'Adresse',
        city: 'Ville',
        phone: 'Téléphone',
        fax: 'Fax',
        wheelchairAccess: 'Accès fauteuil roulant',
        typeOfPractice: 'Type de pratique',
        principal: "Principal"
      },
      specialties: 'Spécialités',
      specialitiesDate: 'Date de délivrance du (des) certificats de spécialiste',
      limitation: {
        label: 'Avis de limitation',
        startDate: 'Début',
        endDate: 'Fin',
      },
      assurance: {
        label: 'Assurance',
        hasAssurance: 'Avec assurance responsabilité professionnelle',
        hasNoAssurance: 'Sans assurance'
      },
      workAddress: {
        label: 'Lieux de pratique'
      },
      memberHistory: {
        label: 'Historique du membre',
        swearingDate: "Date d'assermentation",
        firstInscriptionDate: "Date de première inscription au tableau de l'Ordre",
        dateDmd: 'Date de délivrance du permis',
        specialty: {
          obtainedDate: 'Date d’obtention',
          description: 'Spécialité'
        }
      },
      print: 'Imprimer',
      accessible: 'Cette clinique est accessible aux personnes à mobilité réduite',
      isAnesthesiaPrivateClinic: 'Soins dentaires sous anesthésie générale en clinique privée',
      isAnesthesiaHospital: 'Soins dentaires sous anesthésie générale en milieu hospitalier',
      isParticularMedicalCondition: 'Soins aux patients présentant une condition médicale particulière',
      isHomeVisit: "Soins dentaires à domicile",
      isSleepApnea: "Soins en lien avec le traitement de l’apnée du sommeil",
      isReducedMobility: 'Clinique dentaire accessible aux personnes à mobilité réduite',
      isLiftPerson: "Dispose d'un lève-personne",
      memberSpecification: 'Activités professionelles particulières',
      inactiveSince: ' depuis le '
    }
  }
}